import React from "react";
import { connect } from "react-redux";
import CommonCard from "./CommonCard"
import UsersCard from "./UsersCard"
import AddIcon from "../UIComponents/AddIcon";
import { getMMPLUsersList, DeleteMMPLUser } from "../Actions/UserManagementAPI";
import { confirmAlert } from 'react-confirm-alert';
import axios from "axios";
import API from "../helpers/api";

class UserManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                email: '',
                PageNumber: 1,
                PageSize: 25
            },
            ships: [],
            Users: []
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.SearchData = this.SearchData.bind(this);
    }

    componentDidMount() {
        const { match, dispatch } = this.props;
        dispatch({ type: 'SubBannerTitle', data: "MMPL User Management" });
        this.props.dispatch(getMMPLUsersList(this.state.searchData));
    }

    handleInputChange(e) {
        this.state.searchData.email = e.target.value;
        if (e.target.value === "") {
            this.props.dispatch(getMMPLUsersList(this.state.searchData));
        }
        this.setState({});
    }

    SearchData(Pgno) {
        this.state.searchData.PageNumber = Pgno;
        this.props.dispatch(getMMPLUsersList(this.state.searchData));
    }

    DeletePopup(item) {
        confirmAlert({
            message: 'Are you sure want to delete ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.DeleteUser(item)
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
        }

    DeleteUser(items) {
        let listitem = {}
        let url = `${API.UserAPI}?userid=${items.userId}`
        axios.get(url)
            .then((response) => {
                listitem = {
                    userId: response.data.userId,
                    emailId: response.data.emailId,
                    isAdmin: response.data.isAdmin,
                    isDeleted: true,
                    modifiedBy: '',
                    mmplShips: '',
                    //  response.data.mmplUserShips.map(r => {
                    //     let mmplship = {
                    //         mmplUserShipId: r.mmplUserShipId,
                    //         shipName: r.shipName
                    //     }
                    //      return mmplship
                    // })
                }
                this.props.dispatch(DeleteMMPLUser(listitem));
            })
    }

    ClearInput = () => {
        this.state.searchData.email = "";
        this.props.dispatch(getMMPLUsersList(this.state.searchData));
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    render() {
        const { showSidePane, UsersList } = this.props;

        return (
            <div className="full-height">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                        </button>
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="panel-box">
                                        <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                    MMPL User Management
                                                </h5>
                                                <div className="m-1 flex"
                                                    onClick={() =>
                                                        this.AddUser()
                                                    }>
                                                    <span className="card-title m-auto">Add</span>
                                                    <AddIcon />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="search-filter-box">
                                            <div className="row pb-3">
                                                <div className={showSidePane ? "col-lg-6 " : "col-lg-6 "}>
                                                    <label className="form-label">User Id</label>
                                                    <br></br>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        name="email"
                                                        placeholder="User Id"
                                                        value={this.state.searchData.email}
                                                        onChange={e => this.handleInputChange(e)}
                                                    ></input>
                                                </div>
                                                <div className={showSidePane ? "col-lg-6" : "col-lg-6"}>
                                                    <label className="mt-4"></label><br></br>
                                                    <div
                                                        className="search-btn-col"
                                                        style={{ textAlign: "end" }}
                                                    >
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                            type="submit"
                                                            onClick={() => this.SearchData(1)}
                                                        >
                                                            {" "}Search{" "}
                                                        </button>

                                                        <button
                                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button"
                                                            onClick={() => this.ClearInput()}
                                                        >
                                                            {" "}Clear{" "}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {UsersList ? (
                                <UsersCard
                                    arraylist={UsersList.data}
                                    pageSize={UsersList.pagination ? UsersList.pagination.pageSize : 0}
                                    totalRecords={UsersList.pagination ? UsersList.pagination.totalcount ? UsersList.pagination.totalcount : 0 : 0}
                                    setUpdatedState={(value) => this.SearchData(value)}
                                    DeleteUser={(items) => this.DeletePopup(items)}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    AddUser = () => {
        //  this.props.dispatch({ type: "ShowSidePan", data: true });
        this.props.history.push(`/Home/Management/AddUser`);
    };
}



function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        UsersList: state.UserManageReducer.UsersList,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserManagement);
